module.exports = __webpack_public_path__ + "img/image27.fac8d263.webp";